// src/sections/Hero/Hero.js
import React from 'react';
import styles from './Hero.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faClock, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';

const Hero = ({ id }) => {
  return (
    <section id={id} className={styles.hero}>
      <div className={styles.heroContentWrapper}>
        <div className={styles.heroContent}>
          {/* Le slogan principal reste inchangé */}
          <h2 className={styles.slogan}>Street Food Zen</h2> 
          <h1 className={styles.title}>Le Poké</h1>

          {/* Nouveau : le slogan secondaire "Trop de Bowl !" en mode publicitaire */}
          <p className={styles.secondarySlogan}>Trop de Bowl!</p>

          {/* CHANGEMENT ICI : Le lien pointe vers la section Commander par Téléphone */}
          <a href="#commander-par-telephone" className={styles.ctaButton}>
            <FontAwesomeIcon icon={faPhoneAlt} />
            <span>Commander par Téléphone</span>
          </a>
          <p className={styles.ctaNote}>
            Vente à emporter - Pensez à commander !
          </p>
        </div>

        {/* Contenu de droite (texte gourmand) reste inchangé */}
        <div className={styles.rightContent}>
          <p className={styles.rightText}>
            Des saveurs uniques, <br />
            préparées avec passion. <br />
            Votre évasion gourmande <br />
            à chaque bouchée.
          </p>
        </div>
      </div>

      {/* Barre d'information en bas de la section Hero */}
      <div className={styles.infoFooter}>
        <div className={styles.infoFooterItem}>
          <FontAwesomeIcon icon={faMapMarkerAlt} />
          <span>15 place du 8 Mai 1945 - SAMATAN</span>
        </div>
        <div className={styles.infoFooterItem}>
          <FontAwesomeIcon icon={faClock} />
          <span>Lun-Sam: 9h-14h | Jeu & Ven soir: 18h-21h</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;